import { Progress } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import useNotification from 'ui/base/Notification';

import {
  getLengthToUpload,
  getNbFilesToUpload,
  getCurrentModelUploading,
} from '../../../../../selectors/modelSelectors';

const key = 'MODEL_PROGRESS_UPLOAD';

const useModelProgress = () => {
  const intl = useIntl();
  const notification = useNotification();
  const max = useSelector(getLengthToUpload);
  const fileName = useSelector(getCurrentModelUploading);
  const nbFilesToUpload = useSelector(getNbFilesToUpload);

  const [startUpload, setStartUpload] = React.useState(false);

  React.useEffect(() => {
    if (max) {
      setStartUpload(true);
      const percent = Math.trunc(100 - (100 / max) * nbFilesToUpload);

      notification.open({
        key,
        icon: <Progress type="circle" percent={percent} width={40} />,
        title: intl.formatMessage(
          {
            id: 'page.configurator.models.notification.upload.progress',
            defaultMessage: 'The model {fileName} is uploading ...',
          },
          { fileName }
        ),
        duration: 0,
      });
    }

    if (startUpload && nbFilesToUpload === 0) {
      notification.open({
        key,
        icon: <Progress type="circle" percent={100} width={40} />,
        title: intl.formatMessage({
          id: 'page.configurator.models.notification.upload.success',
          defaultMessage: 'Models are uploaded with success',
        }),
        duration: 0,
      });
      setStartUpload(false);
    }
  }, [nbFilesToUpload, fileName, notification, intl]);

  return null;
};

export default useModelProgress;
